/**
 * Reactor paste. The rare crafting material, scraped out of things that were sealed for a reason.
 */

import type { JunkItem } from '@/sim/items/itemContract';

export const REACTOR_PASTE = {
  id: 'reactorPaste',
  kind: 'junk',
  label: 'Reactor paste',
  description: 'Domestic grade. Coldbrook advises below sixty degrees and away from the children.',
  rarity: 'rare',
  weightKg: 0.5,
  stackLimit: 12,
  equip: null,
  scrapValue: 74,
} as const satisfies JunkItem;
